import { render, staticRenderFns } from "./SimDeliveryLinksPage.vue?vue&type=template&id=3c7ea2be&"
import script from "./SimDeliveryLinksPage.vue?vue&type=script&lang=js&"
export * from "./SimDeliveryLinksPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports